<script setup>
/**
 * FormControlTemplatesTemplatesLazyLoad
 * A checkbox that is only visible when beta mode is enabled.
 * This component wraps the standard FormControlTypeCheckbox and applies conditional visibility logic.
 */
import { getCurrentInstance } from 'vue';
import FormControlTypeCheckbox from '../form-control-type/FormControlTypeCheckbox.vue';

const { proxy } = getCurrentInstance();
const store = proxy.$store;

const props = defineProps({
    formId: String,
    field: Object,
    currentData: Object,
});

if (!store.state.betaMode) {
    props.field.hidden = true;
}
</script>

<template>
    <FormControlTypeCheckbox
        :form-id="formId"
        :field="field"
        :current-data="currentData"
    />
</template>